(function ($) {

    "use strict";

    window.addEventListener("DOMContentLoaded", function () {

        var windowWidth = window.innerWidth;

        function animateImages() {
          setTimeout(function () {
            var imagesToAnimate = document.getElementsByClassName("grid-product__wrapper");
            var i = 0;
            while (i < imagesToAnimate.length) {
                new Waypoint({
                    "element": imagesToAnimate[i],
                    "handler": function(direction) {
                        if (direction === "down") {
                            this.element.classList.add("animated");
                        }
                    },
                    "offset": "80%"
                });
                i += 1;
            }
          }, 1000);
        }

        animateImages();

    });

}(jQuery));